import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { api } from '../../lib/api';

const PortalForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!email) { setError('Please enter your email address.'); return; }
    setLoading(true);
    setError('');
    try {
      await api.clientAuth.forgotPassword(email);
      setSent(true);
    } catch (err: any) {
      setError(err.message || 'Failed to process request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#F8FAFC',
      backgroundImage: 'radial-gradient(ellipse at 20% 0%, rgba(13,148,136,0.08) 0%, transparent 50%)',
      padding: '20px',
    }}>
      <div style={{
        width: '100%', maxWidth: '420px', background: 'white',
        borderRadius: '16px', padding: '40px 36px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.06)', border: '1px solid #E2E8F0',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <img src="/logo.png" alt="VOP CRM" width={140} style={{ marginBottom: '16px' }} />
          <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 700, color: '#1E293B' }}>Forgot Password</h1>
          <p style={{ margin: '8px 0 0', color: '#64748B', fontSize: '14px' }}>
            Enter your email and we'll send you a reset link.
          </p>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '64px', height: '64px', borderRadius: '50%', margin: '0 auto 16px',
              background: 'rgba(16,185,129,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Icon icon="solar:letter-bold" width={36} style={{ color: '#10B981' }} />
            </div>
            <h2 style={{ color: '#1E293B', fontSize: '18px', margin: '0 0 8px' }}>Check Your Email</h2>
            <p style={{ color: '#64748B', fontSize: '14px', margin: '0 0 24px' }}>
              If an account with <strong>{email}</strong> exists, we've sent a password reset link.
            </p>
            <Link to="/portal/login" style={{ color: '#0D9488', fontWeight: 600, textDecoration: 'none' }}>
              Back to Login
            </Link>
          </div>
        ) : (
          <>
            {error && (
              <div style={{
                background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '8px',
                padding: '10px 14px', marginBottom: '16px', color: '#DC2626', fontSize: '13px',
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Email Address</label>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: '10px', border: '1px solid #E2E8F0',
                  borderRadius: '10px', padding: '10px 14px', background: '#F8FAFC',
                }}>
                  <Icon icon="solar:letter-bold-duotone" width={18} style={{ color: '#94A3B8' }} />
                  <input type="email" placeholder="you@email.com" value={email} onChange={e => setEmail(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                    style={{ flex: 1, border: 'none', outline: 'none', background: 'none', fontSize: '14px', color: '#1E293B', fontFamily: 'inherit' }} />
                </div>
              </div>

              <button onClick={handleSubmit} disabled={loading} style={{
                width: '100%', padding: '12px', border: 'none', borderRadius: '10px', cursor: 'pointer',
                background: 'linear-gradient(135deg, #0D9488 0%, #0F766E 100%)',
                color: 'white', fontWeight: 600, fontSize: '15px', fontFamily: 'inherit',
                opacity: loading ? 0.7 : 1,
              }}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>

              <div style={{ textAlign: 'center' }}>
                <Link to="/portal/login" style={{ color: '#0D9488', fontSize: '13px', textDecoration: 'none', fontWeight: 500 }}>
                  Back to Login
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PortalForgotPassword;
